export default "__VITE_ASSET__BqNsE6PF__"